import { QuantityModule } from './QuantityModule';

export type { QuantityModuleDesign } from './QuantityModule';

export default QuantityModule;
